import { LASSO_MIN_POINTS } from "./maplibre-lasso-select.constants";

export /** What the next click will do, in the same three stages geoman narrated. */
const resolveLassoHintKey = (placedCount: number): string => {
  if (!placedCount) {
    return "station.mapDrawFirstVertex";
  }

  return placedCount >= LASSO_MIN_POINTS
    ? "station.mapDrawFinish"
    : "station.mapDrawContinue";
};
